module.exports = __webpack_public_path__ + "static/media/S12_black.08feca48.png";